import { render, staticRenderFns } from "./ExcessoDeEstoque.vue?vue&type=template&id=e81b71d4&scoped=true"
import script from "./ExcessoDeEstoque.vue?vue&type=script&lang=js"
export * from "./ExcessoDeEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b71d4",
  null
  
)

export default component.exports